export default __webpack_public_path__ + "static/media/strasbourg4.9015dcb8.jpg";